/**
 * Step 1 of reading a statement: find out which bank it is from, so the right extractor profile
 * (bankProfiles.js) is used. Order of evidence:
 *   1. IFSC prefix printed in the statement (strongest, e.g. "TMBL", "HDFC", "IBKL")
 *   2. bank name / website markers in the text
 *   3. otherwise "generic"
 */
import { IFSC_BANKS, detectAccount } from "./statementPdf.js";

const NAME_MARKERS = [
  ["TMBL", [/tamilnad\s*mercantile/i, /tmbank\.in/i, /\btmb\b.*bank/i]],
  ["HDFC", [/hdfc\s*bank/i, /hdfcbank\.com/i]],
  ["IBKL", [/idbi\s*bank/i, /idbi\.co\.in/i, /\bidbi\b/i]],
  ["SBIN", [/state\s*bank\s*of\s*india/i, /onlinesbi/i]],
  ["ICIC", [/icici\s*bank/i]],
  ["UTIB", [/axis\s*bank/i]],
  ["KVBL", [/karur\s*vysya/i]],
  ["CIUB", [/city\s*union\s*bank/i]],
  ["IOBA", [/indian\s*overseas\s*bank/i]],
  ["IDIB", [/\bindian\s*bank\b/i]],
  ["CNRB", [/canara\s*bank/i]],
  ["KKBK", [/kotak\s*mahindra/i]]
];

export function detectBank(pages) {
  const account = detectAccount(pages);
  const prefix = String(account.ifsc || "").slice(0, 4).toUpperCase();
  if (prefix && IFSC_BANKS[prefix]) {
    return { code: prefix, name: IFSC_BANKS[prefix], confidence: "ifsc", ifsc: account.ifsc };
  }
  // Only the first page's top part is needed for the bank name; legends further down may mention other banks
  const headText = (pages[0] || []).slice(0, 40).map((l) => l.items.map((i) => i.str).join(" ")).join("\n");
  const hit = NAME_MARKERS.find(([, res]) => res.some((re) => re.test(headText)));
  if (hit) return { code: hit[0], name: IFSC_BANKS[hit[0]] || hit[0], confidence: "name", ifsc: account.ifsc };
  return { code: "GENERIC", name: account.bankName || "Unknown bank", confidence: "none", ifsc: account.ifsc };
}
